import React from "react";
import { Row, Col } from "react-grid-system";
import { Link } from "gatsby";

function PatientHero() {
  return (
    <div className="hero-wrapper row-full">
        <div className="hero-wrapper-inner">
          <div className="hero">
            <Row>
              <Col lg={7} md={10} sm={12}>
                <h1>LEARN ABOUT AN<br /><span>EXTENDED-RELEASE</span><br />HYDROCODONE</h1>
                <p className="hero-text">You may be eligible to save on your Hysingla ER prescription.</p>
                <Link to="/savings-program/" className="hero-link">Go to Savings Program</Link>
              </Col>
            </Row>

          </div>
        </div>
      </div>
  );
}

export default PatientHero ;
